import React from "react";
import GlobalContacts from "./ContactSections/GlobalContacts";

import Footer from "../components/Footer";

const ContactUs: React.FC = () => {
  return (
    <div className="contact-us-container">
      <section>
        <GlobalContacts />
      </section>

      <section style={{ marginTop: "80px" }}>
        <Footer />
      </section>

    </div>
  );
};

export default ContactUs;
